"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieAuthProfile = void 0;
class CookieAuthProfile {
    constructor(sessionToken, xsrfToken) {
        this.headers = getCookieAuthHeaders(sessionToken, xsrfToken);
    }
    getAuthHeaders() {
        return { ...this.headers };
    }
}
exports.CookieAuthProfile = CookieAuthProfile;
function getCookieAuthHeaders(sessionToken, xsrfToken) {
    const headers = { Cookie: getCookieAuthHeader(sessionToken, xsrfToken) };
    if (xsrfToken) {
        headers['X-XSRF-TOKEN'] = xsrfToken;
    }
    return headers;
}
function getCookieAuthHeader(sessionToken, xsrfToken) {
    const pieces = [['connect.sid', sessionToken]];
    if (xsrfToken) {
        pieces.push(['XSRF-TOKEN', xsrfToken]);
    }
    return pieces.map((piece) => piece.join('=')).join(';');
}
//# sourceMappingURL=cookie-auth.profile.js.map